import { useQuery } from "@tanstack/react-query";
import { themesRepo } from "@/lib/repositories";
import { mapThemeToTopicStat } from "./map-theme-to-topic-stat";

// High enough to fetch every topic in a single page for the table/chart.
const ALL_TOPICS_LIMIT = 100;

export function useSuccessRatePerTopic() {
  const query = useQuery({
    queryKey: ["stats", "success-rate-per-topic"],
    queryFn: () =>
      themesRepo.fetchList({
        with_success_rate: true,
        limit: ALL_TOPICS_LIMIT,
      }),
    select: (data) => data.results.map(mapThemeToTopicStat),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
